export default {
      id: "cart-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "img/icons.svg#cart",
      toString: function () {
        return this.url;
      }
    }